<template>
  <ValidationProvider :rules="rules" :name="name" :vid="vid" v-slot="{ errors }">
    <v-text-field
      v-model="currentValue"
      :error-messages="errors"
      :label="labelValue"
      :placeholder="placeholderValue"
      :type="type"
      v-on:change="updateValue"
      :maxlength="maxlength"
      counter>
    </v-text-field>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  name: 'ValidatedInput',
  components: {
    ValidationProvider,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    rules: {
      type: [String, Object],
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    vid: {
      type: String,
      default: undefined,
    },
    type: {
      type: String,
      default: 'text',
    },
    labelValue: {
      type: String,
      default: 'Text',
    },
    placeholderValue: {
      type: String,
      default: 'Enter text',
    },
    maxlength: {
      type: Number,
      default: undefined,
    },
  },
  data: () => ({
    currentValue: undefined,
  }),
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    },
  },
  watch: {
    value(val) {
      this.currentValue = val; // watch for changes on v-model from parent
    },
  },
};
</script>
